import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.app/gatsby-image
 * - `StaticQuery`: https://gatsby.app/staticquery
 */

const Climbing = () => (
  <StaticQuery
    query={graphql`
      query {
        climbing: file(relativePath: { eq: "climbing.png" }) {
          childImageSharp {
            fluid(maxWidth: 1000, traceSVG: { color: "#000" }) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    `}
    render={data => <Img imgStyle={{ objectFit: 'contain' }} alt="Rock climbing image" fluid={data.climbing.childImageSharp.fluid} />}
  />
)

export default Climbing
